export default __webpack_public_path__ + "static/media/Deco.29e7eed8.jpg";